var $963bdb22b62b6b3d$exports = {};
$963bdb22b62b6b3d$exports = {
    "backButton": (args)=>`Voltar ao ${args.prevMenuButton}`,
    "moreActions": `Mais a\xe7\xf5es`,
    "unavailable": `Indispon\xedvel, expandir para mais detalhes`
};


export {$963bdb22b62b6b3d$exports as default};
//# sourceMappingURL=pt-PT.mjs.map
